// @ts-nocheck
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const ButtonOptionsWrapper: StatelessFunctionalComponent<any> = styled.div`
  .button-options {
    &__item {
      margin-right: 2.4rem;
    }
  }

  button:last-child {
    margin: 0;
  }
`;
export default ButtonOptionsWrapper;
